const MeetingTranscriptionsConstants = {
  Actions: {
    INVITE_BOT_SUCCESS: 'meeting_transcriptions/INVITE_BOT_SUCCESS',
    REMOVE_BOT_SUCCESS: 'meeting_transcriptions/REMOVE_BOT_SUCCESS',
    FETCH_BOT_SUCCESS: 'meeting_transcriptions/FETCH_BOT_SUCCESS',
    FETCH_BOTS_SUCCESS: 'meeting_transcriptions/FETCH_BOTS_SUCCESS',
    ACTION_CABLE_BOT_ADDED_SUCCESS: 'meeting_transcriptions/ACTION_CABLE_BOT_ADDED_SUCCESS',
    ACTION_CABLE_BOT_REMOVED_SUCCESS: 'meeting_transcriptions/ACTION_CABLE_BOT_REMOVED_SUCCESS',
    ACTION_CABLE_ACTION_ITEM_ADDED_SUCCESS: 'meeting_transcriptions/ACTION_CABLE_ACTION_ITEM_ADDED_SUCCESS',
    ACTION_CABLE_SUMMARY_GENERATED_SUCCESS: 'meeting_transcriptions/ACTION_CABLE_SUMMARY_GENERATED_SUCCESS',
    FETCH_MEETING_TRANSCRIPTION_SUCCESS: 'meeting_transcriptions/FETCH_MEETING_TRANSCRIPTION_SUCCESS',
    UPDATE_DISMISS_MEETING_SUMMARY_SUCCESS: 'meeting_transcriptions/UPDATE_DISMISS_MEETING_SUMMARY_SUCCESS',
  },
  State: {
    WORKSPACE_BOTS: 'WORKSPACE_BOTS',
  },
} as const;

export default MeetingTranscriptionsConstants;
